import React from 'react';

import { noop } from 'ui-components/default-props/noop';

import { ProviderTypes } from './constants';
import { CuiProviderDeletion } from './delete-provider';
import { useApiCodeFromAccountId } from './hooks/use-api-code-from-account-id';

type FreightProviderDeletionProps = {
  sellerFreightProviderId: number | string;
  onRemoveAccount?: () => void;
  onError?: (error?: unknown) => void;
  onCancel?: () => void;
};

export const DeleteFreightProvider = ({
  sellerFreightProviderId,
  onRemoveAccount = noop,
  onError = noop,
  onCancel = noop,
}: FreightProviderDeletionProps) => {
  const providerApiCode = useApiCodeFromAccountId(sellerFreightProviderId, ProviderTypes.freight);

  if (!providerApiCode) {
    return null;
  }

  return (
    <CuiProviderDeletion
      accountId={String(sellerFreightProviderId)}
      onCancel={onCancel}
      onError={onError}
      onRemoveAccount={onRemoveAccount}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.freight}
    />
  );
};
